<template>
  <div>
    <!-- 垂直形式 -->
    <detail-card
      v-loading="loading"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.5)"
    >
      <template slot="content">
        <md-content
          v-if="vertical"
          :style="styleObject"
          class="md-layout waterfall md-scrollbar"
          ref="waterfall_content"
          @scroll="handleScroll"
        >
          <div
            v-for="(renderCol,index) in renderData"
            :key="index"
            :ref="`fall_${index}`"
            :class="classObject"
          >
            <detail-item>
              <div slot="context">
                <md-card
                  v-for="(item,index) in renderCol"
                  :key="index"
                  @click.native="changeDetailId(item.feed_id)"
                >
                  <md-card-media>
                    <img :src="item.attach" alt="People">
                  </md-card-media>

                  <md-card-content>
                    <code-render style="text-align:left">{{ item.feed_content }}</code-render>
                  </md-card-content>

                  <md-card-actions>
                    <div class="card-footer">
                      <span class="user" :text="item.uname">{{ item.uname }}</span>
                      <span class="time">{{ item.publish_time }}</span>
                    </div>
                  </md-card-actions>
                </md-card>
              </div>

              <template
                slot="detail"
                v-loading="detailLoading"
                element-loading-text="拼命加载中"
                element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(0, 0, 0, 0.8)"
              >
                <div class="dialog-btn-left">
                  <md-button class="md-fab" @click="changeDetailLeft" style="background:#fff;">
                    <font-awesome-icon icon="chevron-left"/>
                  </md-button>
                </div>
                <iframe
                  style="width:100%;height:100%;"
                  frameborder="no"
                  :src="`http://i-wq.net/wqproject_company/index.php/295?app=public&mod=Feed&act=detail&feed_id=${detailId}&table=feed`"
                ></iframe>
                <div class="dialog-btn-right">
                  <md-button class="md-fab" @click="changeDetailRight" style="background:#fff;">
                    <font-awesome-icon icon="chevron-right"/>
                  </md-button>
                </div>
              </template>
            </detail-item>
          </div>
          <div class="addmore">
            <md-button v-show="isComplete" disabled>没有更多</md-button>
            <md-button v-show="!isComplete" class="md-primary" @click.native="addMore">
              加载更多
              <font-awesome-icon icon="angle-down"/>
            </md-button>
          </div>
        </md-content>
      </template>
    </detail-card>

    <!-- 水平形式 -->
    <div
      v-loading="loading"
      v-if="!vertical"
      :style="styleObject"
      class="waterfall horizontal"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.8)"
    >
      <div v-for="(item,index) in alldata" :key="index" :ref="`fall_${index}`" :class="classObject">
        <md-card>
          <md-card-media>
            <img :src="item.attach" alt="People">
          </md-card-media>
          <md-card-content>
            <code-render>{{ item.feed_content }}</code-render>
          </md-card-content>
          <md-card-actions>
            <div class="card-footer">
              <span class="user">{{ item.uname }}</span>
              <span class="time">{{ item.publish_time }}</span>
            </div>
          </md-card-actions>
        </md-card>
      </div>

      <!-- 加载更多 -->
      <div class="addmore">
        <md-button v-show="isComplete" disabled>没有更多</md-button>
        <md-button v-show="!isComplete" class="md-primary" @click.native="addMore">
          加载更多
          <font-awesome-icon icon="angle-down"/>
        </md-button>
      </div>
    </div>
  </div>
</template>

<script>
import CodeRender from "./CodeRender.vue";
import DetailCard from "@/components/DetailCard/index";
import DetailItem from "@/components/DetailCard/DetailItem";
import { getDynamic } from "@/api/dynamic";
import { setTimeout } from "timers";
export default {
  components: {
    CodeRender,
    DetailCard,
    DetailItem
  },
  props: {
    url: {
      type: String,
      required: false,
      default: ""
    },
    urlOption: {
      type: Object,
      required: false,
      default: function() {
        return {};
      }
    },
    count: {
      type: Number,
      required: false,
      default: 5
    },
    vertical: {
      type: Boolean,
      required: false,
      default: true
    },
    width: {
      type: String,
      required: false,
      default: "0"
    },
    height: {
      type: String,
      required: false,
      default: ""
    },
    data: {
      type: Array,
      required: false,
      default: function() {
        return [];
      }
    },
    dataOption: {
      type: Object,
      required: false,
      default: function() {
        return {};
      }
    }
  },
  data() {
    return {
      alldata: [],
      flag: 0,
      col: 5,
      loading: false,
      detailLoading: false,
      isUrlData: true,
      urlModeComplete: false,
      detailId: 0,
      inScroll: false
    };
  },
  computed: {
    styleObject() {
      const styleObject = {};
      if (this.width !== "") {
        styleObject.minWidth = `${this.width}px`;
      }
      if (this.height !== "") {
        styleObject.maxHeight = `${this.height}px`;
      }
      return styleObject;
    },
    classObject() {
      const classObject = {
        "md-layout-item": true
      };
      const className = "md-size-" + 100 / this.count;
      classObject[className] = true;
      return classObject;
    },
    renderData() {
      const renderData = new Array(this.count);
      let i = 0;
      this.showData.forEach((item, index) => {
        if (item.attach == null) {
          return;
        }
        if (!(renderData[i] instanceof Array)) {
          renderData[i] = [];
        }
        renderData[i++].push(item);
        if (i % this.count === 0) {
          i = 0;
        }
      });
      return renderData;
    },
    showData() {
      let showData = [];
      showData = this.alldata.slice(0, this.flag);
      return showData;
    },
    isComplete() {
      if (this.isUrlData) {
        return this.urlModeComplete;
      }
      return this.flag === this.alldata.length;
    }
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      /*
        初始化轮播图
        判断是否为url模式=>{

          urlOption:{
            method: 'GET',
            param: '参数',
            map:{
              attach:''//图片
              feed_content:''内容
              uname: '' //发布人名
              publish_time:'' 时间
            }
          }
          url模式=> 拉取数据

          数据模式=> 导入所有数据
        }
      */
      if (this.url !== "") {
        this.isUrlData = true;
        this.initUrlMode();
      }
      if (this.data.length !== 0 && this.url === "") {
        this.isUrlData = false;
      }
      // this.isUrlData = false
      if (this.isUrlData) {
        this.flag = 0;
      } else {
        this.addFlag();
      }
    },
    initUrlMode() {
      getDynamic(this.urlOption).then(response => {
        if (response.data.feed == null) {
          this.urlModeComplete = true;
        } else {
          for (let i = 0; i < response.data.feed.length; i++) {
            this.alldata.push(response.data.feed[i]);
          }
        }
        this.addFlag();
      });
    },
    addFlag() {
      this.flag =
        this.flag + this.dataOption.item > this.alldata.length
          ? this.alldata.length
          : this.flag + this.dataOption.item;
    },
    addMore() {
      this.loading = true;
      if (!this.isUrlData) {
        this.addFlag();
      } else {
        this.urlOption.start += this.urlOption.limit;
        getDynamic(this.urlOption).then(response => {
          if (response.data.feed == null) {
            this.urlModeComplete = true;
          } else {
            response.data.feed.forEach(element => {
              this.alldata.push(element);
            });
          }
          setTimeout(() => {
            this.loading = false;
          }, 300);
          this.addFlag();
        });
      }
    },
    changeDetailId(id) {
      this.detailId = id;
    },
    changeDetailLeft() {
      const loading = this.$loading({
        lock: true,
        text: "加载中,请稍后",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      setTimeout(() => {
        loading.close();
      }, 2000);
      let detailIdList = this.alldata.map(ele => {
        return ele.feed_id;
      });
      let index = detailIdList.indexOf(this.detailId);
      if (index == 0) {
        this.detailId = detailIdList[detailIdList.length - 1];
      } else {
        this.detailId = detailIdList[index - 1];
      }
    },
    changeDetailRight() {
      const loading = this.$loading({
        lock: true,
        text: "加载中,请稍后",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      setTimeout(() => {
        loading.close();
      }, 2000);
      let detailIdList = this.alldata.map(ele => {
        return ele.feed_id;
      });
      let index = detailIdList.indexOf(this.detailId);
      if (index == detailIdList.length - 1) {
        this.detailId = detailIdList[0];
      } else {
        this.detailId = detailIdList[index + 1];
      }
    },
    //滚动加载
    handleScroll(e) {
      if (this.inScroll) {
        return;
      }
      let scroll = this.$refs.waterfall_content.$el.scrollTop;
      const distance = 300
      if (distance > this.$refs.waterfall_content.$el.scrollHeight - this.$refs.waterfall_content.$el.offsetHeight - scroll) {
        if (!this.isComplete && !this.inScroll) {
          this.inScroll = true;
          setTimeout(() => {
            this.addMore()
            this.inScroll = false;
          }, 500);
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.md-card {
  margin: 10px 10px;
  min-width: 100px;
}
.waterfall {
  overflow: auto;
  padding: 0 20px;
}
.addmore {
  display: flex;
  justify-content: center;
  width: 100%;
}
.card-footer {
  display: flex;
  justify-content: space-between;
  width: 100%;
  align-items: center;
  .user {
    max-width: 65px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    color: #00a7e1;
    text-decoration: none;
  }
  .time {
    height: 30px;
    line-height: 30px;
    color: #aaa;
  }
}
.horizontal {
  display: flex;
  flex-wrap: nowrap;
  overflow: auto;
  .md-card {
    height: 500px;
    img {
      height: 300px;
    }
    .md-card-content {
      overflow: hidden;
      text-overflow: ellipsis; //文本溢出显示省略号
      display: -webkit-box;
      -webkit-line-clamp: 5;
      -webkit-box-orient: vertical;
    }
  }
}
.dialog-btn-left {
  position: fixed;
  top: 45%;
  color: #00a7e1;
  opacity: 0.6;
  .md-ripple {
    color: #00a7e1 !important;
  }
}
.dialog-btn-right {
  position: absolute;
  right: 0;
  top: 45%;
  opacity: 0.6;
}
</style>

